import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'avatarPipe' })
export class AvatarPipe implements PipeTransform {
  transform(avatar: any) {
    // console.log('avatar');
    if (avatar) {
      if (avatar.facePageId) {
        return `https://graph.facebook.com/${avatar.facePageId}/picture?height=200&width=200&type=square&access_token=${avatar.accessToken}`;
      } else if (avatar.pageId) {
        return `https://graph.facebook.com/${avatar.pageId}/picture?height=200&width=200&type=square&access_token=${avatar.accessToken}`;
      } else {
        return avatar;
      }
    }
    return '../../../../assets/images/defaultImg.jpg';
  }
}
